import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import './AuthPage.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== password2) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      await api.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  if (!token.trim()) {
    return (
      <main className="auth-page container">
        <div className="auth-card card">
          <h1 className="auth-flow-title">Invalid link</h1>
          <p className="auth-flow-lead">This reset link is missing a token. Use the link from your email.</p>
          <Link to="/forgot-password" className="btn btn-primary btn-block auth-submit" style={{ textAlign: 'center', textDecoration: 'none' }}>
            Request a new link
          </Link>
          <p className="auth-privacy" style={{ marginTop: 16 }}>
            <Link to="/">← Back to menu</Link>
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="auth-page container">
      <div className="auth-card card">
        <h1 className="auth-flow-title">Set new password</h1>
        {done ? (
          <>
            <p className="auth-success-text">Your password has been updated. You can sign in now.</p>
            <button
              type="button"
              className="btn btn-primary btn-block auth-submit"
              onClick={() => navigate('/')}
            >
              Continue to menu
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="reset-pass">New password</label>
              <input
                id="reset-pass"
                type="password"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="reset-pass2">Confirm password</label>
              <input
                id="reset-pass2"
                type="password"
                placeholder="Repeat password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            {error && <p className="error-text">{error}</p>}
            <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={submitting}>
              {submitting ? 'Saving…' : 'Save password'}
            </button>
          </form>
        )}
        <p className="auth-privacy" style={{ marginTop: 16 }}>
          <Link to="/forgot-password">Request another link</Link>
        </p>
      </div>
    </main>
  );
}
